import React, { useState } from "react";
import { kval, bookAmount, toCurrency, bookClass } from "./card32Utils";
import Collapse from "../../../components/Collapse";

/**
 * 32 Cards A bet table (card32 / pcard32 / tcard32) — reference markup:
 * .teen1daycasino-container > .teen1dayleft (Player 8, 9) + .teen1daycenter + .teen1dayright (Player 10, 11);
 * each .casino-box-row = .casino-nation-name (b name + .float-right book / (i) range)
 *                      + .casino-bl-box[.suspended] > .back / .lay .casino-bl-box-item > span.casino-box-odd
 * `data` = the card32 markets (sub filtered by subtype "card32", ordered by sr).
 */
export default function BetTableCard32({ data = [], onBetClick, exposures = {} }) {
  const [openRanges, setOpenRanges] = useState({});
  const toggleRange = (id) => setOpenRanges((prev) => ({ ...prev, [id]: !prev[id] }));

  const renderRow = (item, i) => {
    const m = item || {};
    const suspended = m.gstatus !== "OPEN";
    const book = bookAmount(exposures, m.nat);
    const rangeId = `demo${i}`;
    const click = (type) => {
      const v = type === "back" ? m.b : m.l;
      if (!suspended && v && onBetClick) onBetClick(v, m.nat, type, m);
    };
    return (
      <div className="casino-box-row">
        <div className="casino-nation-name">
          <b>{m.nat}</b>{" "}
          <div className="float-right">
            <span className={`mr-2 casino-book ${bookClass(book)}`}>{toCurrency(book)}</span>{" "}
            <i className="fas fa-info-circle" onClick={() => toggleRange(rangeId)} />{" "}
            <Collapse id={rangeId} open={!!openRanges[rangeId]} className="icon-range">
              Range: <span>{kval(m.min)}</span>-<span>{kval(m.max)}</span>
            </Collapse>
          </div>
        </div>{" "}
        <div className={suspended ? "casino-bl-box suspended" : "casino-bl-box"}>
          <div className="back casino-bl-box-item" onClick={() => click("back")}>
            <span className="casino-box-odd">{m.b}</span>
          </div>{" "}
          <div className="lay casino-bl-box-item" onClick={() => click("lay")}>
            <span className="casino-box-odd">{m.l}</span>
          </div>
        </div>
      </div>
    );
  };

  if (data.length < 4) return null;

  return (
    <div className="teen1daycasino-container">
      <div className="teen1dayleft">
        {renderRow(data[0], 0)}{" "}
        {renderRow(data[1], 1)}
      </div>{" "}
      <div className="teen1daycenter" />{" "}
      <div className="teen1dayright">
        {renderRow(data[2], 2)}{" "}
        {renderRow(data[3], 3)}
      </div>
    </div>
  );
}
